
export default {
	data() {
		return {
			currentlyYear: null,
			lastYear: null,
		}
	},
}
